const transitionProperties = {
  control: '150ms ease-out',
};

export const transitions = {
  control: `
    background ${transitionProperties.control},
    box-shadow ${transitionProperties.control},
    color ${transitionProperties.control},
    fill ${transitionProperties.control},
    opacity ${transitionProperties.control},
    outline ${transitionProperties.control},
    stroke ${transitionProperties.control},
    transform ${transitionProperties.control}
  `,

  /** The halo alone, for elements that draw one and have nothing else to animate. */
  focusRing: `box-shadow ${transitionProperties.control}`,
};
